<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    authorizedUserID() {
      return this.$store.state.authentication.userId;
    },
    currentDomainID() {
      return this.$store.getters.domainID;
    },
    currentPermissions() {
      return this.$store.getters.permissions;
    }
  },
  watch: {
    authorizedUserID(newUserID) {
      this.onAuthorizedUserIDChanged(newUserID);
    },
    currentDomainID(newDomainID) {
      if (newDomainID) {
        // load roles
        const domainID = this.$store.getters.domainID;
        this.$store.dispatch('role/getItems', { domainID });
        // load permissions
        this.$store.dispatch('permission/getItems');
      }
    },
    currentPermissions(newPermissions, oldPermissions) {
      // Generate routes for side bar
      this.$store.dispatch('permission/generateRoutes', newPermissions);
    }
  },
  created() {
    this.$store.dispatch('language/getItems');
    this.onAuthorizedUserIDChanged(this.authorizedUserID);
  },
  methods: {
    onAuthorizedUserIDChanged(newUserID) {
      if (newUserID) {
        this.$store.dispatch('getUserInfo', {}).then(() => {});
      }
    }
  }
};
</script>
